import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-url",
  "use": "icon-url-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-url\">\n  <path d=\"M10.6,8.199H9.4v-1.2h1.2V8.199z\" />\n  <path d=\"M10,16c-3.308,0-6-2.692-6-6c0-3.308,2.692-6,6-6s6,2.692,6,6C16,13.308,13.308,16,10,16z M10,5.2 c-2.647,0-4.8,2.153-4.8,4.8c0,2.647,2.153,4.8,4.8,4.8c2.647,0,4.8-2.153,4.8-4.8C14.8,7.353,12.647,5.2,10,5.2z\" />\n  <path d=\"M10.6,12.399H9.4v-3h1.2V12.399z\" />\n  <path d=\"M9.4,9.999H8.8v-0.6h0.6V9.999z\" />\n  <path d=\"M11.2,12.399H8.8v-0.6h2.4V12.399z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol